export class InsuranceLogDetail {
    FieldName: string;
    OldValue: string;
    NewValue: string;
}
